export default "__VITE_ASSET__accdfde4__"